import React from "react";
import PropTypes from "prop-types";
import { motion, AnimatePresence } from "framer-motion";
import './popupScrollable.css';

const PopupForm = ({ isOpen, onClose, children }) => {
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <div
          className="popup-scrollable fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
          onClick={handleOverlayClick}
        >
          <motion.div
            className="bg-white rounded-lg shadow-lg p-6 max-h-[80vh] overflow-y-auto w-full max-w-md sm:max-w-lg md:max-w-2xl lg:max-w-4xl xl:max-w-6xl relative"
            initial={{
              scale: 0.9,
              opacity: 0,
              y: 50,
              boxShadow: "0 0 0 rgba(0, 0, 0, 0)",
            }}
            animate={{
              scale: 1,
              opacity: 1,
              y: 0,
              boxShadow: "0 10px 30px rgba(0, 0, 0, 0.2)",
            }}
            exit={{
              scale: 0.9,
              opacity: 0,
              y: 50,
              boxShadow: "0 0 0 rgba(0, 0, 0, 0)",
            }}
            transition={{
              duration: 0.5,
              ease: [0.25, 0.8, 0.25, 1],
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              className="absolute top-2 right-3 text-gray-500 hover:text-white p-2 text-lg rounded-full hover:w-10 hover:h-10 hover:bg-green-800 flex items-center justify-center transition-all"
              onClick={onClose}
            >
              ✕
            </button>

            {children && <>{children}</>}
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

PopupForm.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
};

export default PopupForm;
